<template>
    <li class="nav-item dropdown">
        <a @click="toggleDropDown" class="nav-link nav-link-icon" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-bell"></i>
            <span v-if="hasNewNotificaiton" class="notification-badge badge badge-md badge-circle badge-floating badge-danger border-white" v-text="newNotificationCount"></span>
        </a>
        <div class="dropdown-menu dropdown-menu-arrow dropdown-menu-right" aria-labelledby="navbar-default_dropdown_1" style="min-width: 350px;" ref="dropdown" >
            <card-infinite-scroll-list simple
                @recordloaded="notificationsLoaded"
                max-height="250px"
                :fetch-link="notificaitonsFetchLink"
                paginate-path="data.result.notifications"
                ref="notificationsList"
            >
                <template slot="loading">
                    <div class="p-2">
                        <i class="fa fa-spinner fa-spin pr-1"></i>
                        Loading data, please wait ...
                    </div>
                </template>
                <template slot="body" slot-scope="props">
                    <td class="pt-2 pb-2 pl-3 pr-3 pointer" :class="notificationItemClass(props.record)" @click="() => redirectToPage(props.record)">
                        <!-- <link-button :href="route(props.record.route_name, props.record.route_parameters)" class="text-dark"> -->
                            <div class="row">
                                <div class="col-auto pr-0">
                                    <avatar-badge :src="props.record.image" :size="80" rounded no-margin></avatar-badge>
                                </div>
                                <div class="col notification-text-wrapper">
                                    <div class="text-sm font-weight-bold notification-text" v-text="props.record.title"></div>
                                    <div class="text-sm notification-text" v-text="props.record.content"></div>
                                    <div class="text-sm text-muted notification-date">
                                        <i class="fa fa-clock mr-1 mt-1"></i>
                                        <span v-text="props.record.created_at"></span>
                                    </div>
                                </div>
                            </div>
                        <!-- </link-button> -->
                    </td>
                </template>
            </card-infinite-scroll-list>
            <div class="dropdown-divider"></div>
            
            <div class="dropdown-item">
                <a href="#" class="mr-2" @click.stop="readAll()">Mark all as read</a>
            </div>
        </div>
    </li>
</template>
<script>
import moment from 'moment';
import { bus } from '@utils/bus';
import mixins from '@utils/mixins';
import { get, route, pageRoute } from '@utils/network';
import { getRoute } from "../users/customers/notifications/notification-routes";

export default {
    name: 'NotificationBadge',

    computed: {
        hasNewNotificaiton() {
            return this.newNotificationCount > 0;
        },
    },

    data: () => ({
        newNotificationCount: 0,
        previousNotificationCount: 0,
        notificaitonsFetchLink: route("notifications")
    }),

    methods: {

        route(href, params) {
            return pageRoute(href, params);
        },

        readAll() {
            get(route('notifications/read-all'))
                .then(response => this.markAllAsRead(response))
                .catch(error => this.failedToReadAll(error))
        },

        markAllAsRead(response) {
            this.$refs.notificationsList.records.forEach(notification => {
                if (notification.read_at == null) {   
                    notification.read_at = moment();
                }
            });
        },

        failedToReadAll(error) {
            this.promptErrors(error.message);
        },
        
        isDropDownVisible() {
            return $(this.$refs.dropdown).offsetParent != null
        },

        notificationItemClass(notification) {
            return {
                'bg-light-gray': notification.read_at == null,
            }
        },

        toggleDropDown() {
            if (!this.isDropDownVisible()) {
                return;
            } else if (this.hasNewNotificaiton) {
                this.$refs.notificationsList.refreshTable();
            }
            this.clearUnread();
        },

        clearUnread() {
            this.newNotificationCount = 0;
        },

        recievedNotification(notification) {
            this.newNotificationCount += 1;
            if (this.isDropDownVisible()) {
                this.$refs.notificationsList.refreshTable();
            }
        },

        notificationsLoaded(response) {
            if (this.previousNotificationCount == 0) {
                this.newNotificationCount = response.data.result.newNotificationCount;
            }
            this.previousNotificationCount = response.data.result.notifications.length;
        },

        redirectToPage(notification) {
            const route = getRoute({
                name: notification.route_name,
                parameters: JSON.parse(notification.route_parameters)
            });
            this.$router.push(route);
        },

    },

    mixins: [mixins],

    mounted() {
        bus.$on('notification-recieved', notification => this.recievedNotification(notification));
    },


}
</script>
<style lang="css" scoped>
    .nav-item .nav-link {
        padding: 9.5px 19px;
        font-weight: 700;
    }
</style>